import { Routes, Route, Navigate } from "react-router-dom";
import ViewerHome from "./viewer/Home";
import DepartmentPage from "./viewer/DepartmentPage";
import SearchPage from "./viewer/SearchPage";
import ViewerLayout from "./viewer/ViewerLayout";

import AdminLogin from "./admin/Login";
import AdminLayout from "./admin/components/AdminLayout";
import Dashboard from "./admin/Dashboard";
import AdminDepartments from "./admin/DepartmentsPage";
import AdminDepartmentDetail from "./admin/DepartmentDetailPage";
import AdminUsers from "./admin/UsersPage";
import AdminAudit from "./admin/AuditPage";
import AdminSettings from "./admin/SettingsPage";
import AdminAccount from "./admin/AccountPage";

export default function App() {
  return (
    <Routes>
      {/* Viewer (public) */}
      <Route element={<ViewerLayout />}>
        <Route path="/" element={<ViewerHome />} />
        <Route path="/d/:slug" element={<DepartmentPage />} />
        <Route path="/search" element={<SearchPage />} />
      </Route>

      {/* Admin */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="departments" element={<AdminDepartments />} />
        <Route path="departments/:id" element={<AdminDepartmentDetail />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="audit" element={<AdminAudit />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="account" element={<AdminAccount />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
